import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";
import SiteHeader from "../components/SiteHeader";
import { ArrowRight } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const data = await login(email, password);
      toast.success("Signed in");
      navigate(data?.must_change_password ? "/change-password" : "/app");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <SiteHeader />
      <main className="max-w-md mx-auto px-6 py-20">
        <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">Access your workspace</div>
        <h1 className="font-heading text-3xl font-bold tracking-tight mt-2">Sign in</h1>
        <p className="text-zinc-600 mt-2 text-sm">Log in to check certificates and view your history.</p>

        <form onSubmit={submit} className="mt-8 space-y-5 border border-zinc-200 bg-white rounded-sm p-6">
          <div className="space-y-1.5">
            <Label htmlFor="email" className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                   className="rounded-sm h-10" data-testid="login-email-input" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password" className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">Password</Label>
            <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                   className="rounded-sm h-10" data-testid="login-password-input" />
          </div>
          {error && <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-sm px-3 py-2" data-testid="login-error">{error}</div>}
          <Button type="submit" disabled={loading} className="w-full bg-[#0F172A] hover:bg-[#0F172A]/90 rounded-sm h-10" data-testid="login-submit-btn">
            {loading ? "Signing in…" : (<>Sign in <ArrowRight className="w-4 h-4" /></>)}
          </Button>
        </form>

        <div className="mt-6 text-sm text-zinc-600">
          New here?{" "}
          <Link to="/register" className="text-[#0F172A] underline underline-offset-4" data-testid="login-to-register-link">
            Create an account
          </Link>
        </div>
      </main>
    </div>
  );
}
